import React from "react";
import "./styles.css";
import { FaMusic, FaBook, FaMapMarker } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BiRightArrowAlt } from "react-icons/bi";
import { useState, useEffect } from "react";
import { MidiaLinks } from "../MidiaLinks";
import { BiErrorCircle } from "react-icons/bi";
const TiposSuggestions = (props) => {
  const { type, list, link } = props;

  const [displayModal, setDisplayModal] = useState(null);

  let icon;

  if (type === "Livros") {
    icon = <FaBook style={{ color: "#6184FE" }} />;
  } else if (type === "Locais") {
    icon = <FaMapMarker style={{ color: "#6184FE" }} />;
  } else if (type === "Músicas")
    icon = <FaMusic style={{ color: "#6184FE" }} />;

  return (
    <div className="suggestions-content">
      <div className="suggestions-title">
        {icon}
        <p>{type}</p>
        <div className="suggestions-button-container">
          <div className="suggestions-button">
            <Link to={link}>Ver todos</Link>
          </div>
        </div>
      </div>
      <div></div>
      <div className="suggestions-container">
        {list
          ? list?.map((item) => (
              <div key={item.id}>
                <div className="suggestions-blocos">
                  <div>
                    {displayModal === item.id ? (
                      <MidiaLinks
                        displayModal={displayModal === item.id}
                        setDisplayModal={setDisplayModal}
                        spotifyLink={item.spotify_link}
                        youtubeLink={item.youtube_link}
                        buyLink={item.buy_link}
                      />
                    ) : null}
                  </div>
                  <div>
                    {type === "Músicas" ? (
                      <div
                        className="musicas"
                        style={{ marginTop: "1rem", marginBottom: "-5%" }}
                      >
                        <div>
                          <img
                            onClick={() => setDisplayModal(item.id)}
                            src={"data:image/jpeg;base64," + item.image_link}
                            width="95"
                            id="base64image"
                          />
                        </div>
                        <h2>{item.name}</h2>
                        <div>
                          <h3>{item.author_name}</h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {type === "Locais" ? (
                      <div className="locais" style={{ maxWidth: "125px" }}>
                        <img
                          src={"data:image/jpeg;base64," + item.image_link}
                          width="150"
                          height="100"
                          id="base64image"
                        />
                        <h2 style={{ width: "150px" }}>{item.name}</h2>
                        <div>
                          <h3>{item.address}</h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {type === "Livros" ? (
                      <div className="livros">
                        <div className="imagem">
                          <img
                            onClick={() => setDisplayModal(item.id)}
                            src={"data:image/jpeg;base64," + item.image_link}
                            width="95"
                            id="base64image"
                          />
                        </div>
                        <h2>{item.title}</h2>

                        <div>
                          <h3>{item.author_name}</h3>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            ))
          : null}
        <div className="fade" />
      </div>
    </div>
  );
};

export default TiposSuggestions;
